import { Box, Loader } from 'braid-design-system';
import React from 'react';

export const OverlayLoader = () => (
  <Box
    background="surface"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    position="absolute"
    top={0}
    right={0}
    left={0}
    bottom={0}
    zIndex="modal"
  >
    <Loader />
  </Box>
);
